import { memo, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { conditions, handleSumVotes, isVoted, livePoll, seenPoll } from "helpers";
import useOnClickOutside from "helpers/hooks/useOnClickOutside";
import { setClearPopoversSlice, setPollPopover } from "redux-share/slices/popoversSlice";
import { ConditionName } from "interfaces";
import { setSelectedOptionId } from "redux-share/slices/videoDataSlice";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const Popover = dynamic(() => import("../../popover/popover"));
const PortraitPollOption = dynamic(() => import("./portraitPollOption"));

const Poll = () => {

    const dispatch = useAppDispatch();
    const { question, params } = useAppSelector(({ videoData: { question, params } }) => ({ question, params }), shallowEqual);
    const { pollPopover } = useAppSelector(({ popovers: { pollPopover } }) => ({ pollPopover }), shallowEqual);

    const [sumVotes, setSumVotes] = useState<number>(handleSumVotes(question));
    const [step, setStep] = useState<number>(1);


    const pollRef = useRef<any>(null);

    useOnClickOutside(pollRef, () => {
        dispatch(setPollPopover(false));
        localStorage.setItem("seen-poll", question.id);
    });

    useEffect(() => {
        if (conditions(ConditionName.hasPoll)) {
            setSumVotes(handleSumVotes(question));
            if (!seenPoll() || (seenPoll() && +seenPoll() !== question.id)) {
                dispatch(setClearPopoversSlice());
                dispatch(setPollPopover(true))
            }
        } else {
            dispatch(setClearPopoversSlice());
            dispatch(setPollPopover(true))
        }
    }, [question])

    const handleClickOption = (id: number, vote: number) => {
        dispatch(setSelectedOptionId(id));
        // State 2
        if (question || question.active) {
            if ((!!livePoll() && livePoll().liveId !== params.id) || !livePoll()) {
                localStorage.setItem("live-poll", JSON.stringify({
                    liveId: params.id,
                    polls: [{ qid: question.id, oid: id, sumOptionVotes: vote + 1 }]
                }));
            } else {
                if (livePoll().polls.filter((poll: any) => poll.qid === question.id).length === 0 && question.can_vote) {
                    localStorage.setItem("live-poll", JSON.stringify({
                        liveId: params.id,
                        polls: [...livePoll().polls, { qid: question.id, oid: id, sumOptionVotes: vote + 1 }]
                    }));
                }
            }
        }
        setStep(2)
    }

    useEffect(() => {
        if (conditions(ConditionName.hasPoll)) {
            if (isVoted(question.id)) setStep(2);
            else setStep(1);
        }
    }, [question])

    return (
        <>
            {conditions(ConditionName.hasPoll) && (
                <Popover
                    status={pollPopover}
                    onClose={() => dispatch(setPollPopover(false))}
                    isBlurBackground
                    ref={pollRef}
                    type="popover"
                >
                    <div className="pl-pt-6 pl-pb-4 pl-px-4" style={{ direction: "rtl" }}>
                        <p className={`pl-text-[14px] pl-font-medium pl-w-full ${question.options && question.options.length > 0 && "pl-mb-3"}`}>{question.text}</p>
                        {question.options && question.options.length > 0 && (
                            <>
                                {step === 1 ? (
                                    <main className="pl-flex pl-flex-col pl-gap-4 pl-overflow-auto pl-max-h-[200px] no-scrollbar">
                                        {question.options.map((option: any) => (
                                            <p
                                                key={option.id}
                                                className="pl-border pl-border-dark-4 pl-w-full pl-break-all pl-text-[13px] pl-px-3 pl-py-2 pl-rounded-[4px] pl-cursor-pointer"
                                                onClick={() => handleClickOption(option.id, option.vote)}
                                            >
                                                {option.text}
                                            </p>
                                        ))}
                                    </main>
                                ) : (
                                    <div className="pl-flex pl-flex-col pl-gap-4 pl-overflow-auto pl-max-h-[200px] no-scrollbar" style={{ direction: "rtl" }}>
                                        {question.options.map((option: any) => (
                                            <PortraitPollOption
                                                option={option}
                                                key={option.id}
                                                lastOptionId={question.options.find((item: any) => item.vote === Math.max(...question.options.map((o: any) => o.vote))).id}
                                                sumVotes={sumVotes}
                                                onClick={() => (question.can_vote && !isVoted(question.id)) && handleClickOption(option.id, option.vote)}
                                            />
                                        ))}
                                        <p className="pl-flex pl-gap-1 pl-text-[11px]">
                                            <span>تعداد کل آرا:</span>
                                            <span>{handleSumVotes(question)} نفر</span>
                                        </p>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </Popover>
            )}
        </>
    )
}

export default memo(Poll);
